// You can add Custom JS

// This Code for the Custom Popup Section

document.addEventListener("DOMContentLoaded", function() {
    // Select all elements with the class "btn-open" and "btn-close"
    var openButtons = document.querySelectorAll(".btn-open");
    var closeButtons = document.querySelectorAll(".btn-close");
    var body = document.body; // Select the <body> element
    
    // Select the element with the class "modal-wrapper"
    var modalWrapper = document.querySelector(".modal-wrapper");
    
    // Add click event listeners to each "btn-open" element
    openButtons.forEach(function(button) {
        button.addEventListener("click", function() {
            // Add the "open" class to the modal wrapper
            modalWrapper.classList.add("open");
            body.classList.add("modal-open"); // Add class to <body>
        });
    });
    
    // Add click event listeners to each "btn-close" element
    closeButtons.forEach(function(button) {
        button.addEventListener("click", function() {
            // Remove the "open" class from the modal wrapper
            modalWrapper.classList.remove("open");
            body.classList.remove("modal-open"); // Remove class from <body>
        });
    });
});

// wishlist app JS

// Function to add or remove the "active" class
function addOrRemoveClass() {
  setTimeout(function () {
    if (mywishlistcheck && mywishlistcheck.classList.contains("iwishAdded") && mywishlist) {
      mywishlist.classList.add("active");
    } else if (mywishlist) {
      mywishlist.classList.remove("active");
    }
  }, 1);
}

// Get references to the elements
var mywishlist = document.querySelector(".iwishdot");
var mywishlistcheck = document.querySelector(".iWishAdd");

// Add an event listener for the "click" event on the button
if (mywishlistcheck) {
  mywishlistcheck.addEventListener("click", addOrRemoveClass);
}

// Add an event listener for the "load" event (when the page loads)
window.addEventListener("load", function () {
  // Call the addOrRemoveClass function when the page is fully loaded
  addOrRemoveClass();
});

document.addEventListener("DOMContentLoaded", function() {
  let SizeguideCm = document.querySelector('.size-guide-cm');
  let SizechartInch = document.querySelector('.size-chart-inch');
  
  let SizeguideInch = document.querySelector('.size-guide-inch');
  let SizechartCm = document.querySelector('.size-chart-cm');
  
  if (SizeguideInch && SizechartInch && SizeguideCm && SizechartCm) {
    SizeguideInch.addEventListener("click", () => {
      SizeguideInch.classList.add('show');
      SizechartInch.closest('div').querySelector('.size-chart-inch').classList.add('active');
      SizeguideCm.classList.remove('show');
      SizechartCm.closest('div').querySelector('.size-chart-cm').classList.remove('active');
    });
    
    window.addEventListener("load", function () {
      SizeguideInch.classList.add('show');
      SizechartInch.closest('div').querySelector('.size-chart-inch').classList.add('active');
    });
    
    SizeguideCm.addEventListener("click", () => {
      SizeguideCm.classList.add('show');
      SizechartCm.closest('div').querySelector('.size-chart-cm').classList.add('active');
      SizeguideInch.classList.remove('show');
      SizechartInch.closest('div').querySelector('.size-chart-inch').classList.remove('active');
    });
  }
});



// Create an Intersection Observer object
const options = {
  root: null, // viewport
  rootMargin: "0px", // margin around the viewport
  threshold: 0.5, // percentage of the target element that needs to be visible
};

const observer = new IntersectionObserver(callback, options);
let observedProductCards = [];

// Define the callback function
function callback(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      // Element is in the viewport
      const productItem = entry.target;

      // Extract data from the grid__item grid-product element (customize this part)
      const productId = productItem.getAttribute("data-product-id");
      const productName = productItem.getAttribute("data-product-name");
      const productPrice = productItem.getAttribute("data-product-price");
      const productVendor = productItem.getAttribute("data-product-vendor");
      const productVariant = productItem.getAttribute("data-product-variant");
      const productCollection = productItem.getAttribute(
        "data-product-collection"
      );
      const CollectionId = productItem.getAttribute("data-collection-id");
      const indexNumber = productItem.getAttribute("product-index-number");

      observedProductCards.push({
        item_id: productId,
        item_name: productName,
        index: indexNumber,
        item_brand: productVendor,
        item_list_id: CollectionId,
        item_list_name: productCollection,
        item_variant: productVariant,
        price: productPrice,
        quantity: 1,
      });

      if (observedProductCards.length >= 2) {
        gtag("event", "view_item_list", {
          send_to: "G-WQS1KBXWX1",
          item_list_id: CollectionId,
          item_list_name: productCollection,
          items: observedProductCards,
        });

        // Clear the observed product cards array
        observedProductCards = [];
      }

      // Unobserve the target element
      // observer.unobserve(productItem);
    }
  });
}

// Observe all elements with the class [grid__item grid-product]
const productItems = document.querySelectorAll(".product-card");
productItems.forEach((productItem) => {
  observer.observe(productItem);
});

// GA Events Code Push on Click Product Cards Collection Page
document.addEventListener("DOMContentLoaded", function () {
  let collectionItems = document.querySelectorAll(".merca_plp_click");

  const handleClick = function () {
    const productName = this.getAttribute("data-product-name");
    const productId = this.getAttribute("data-product-id");
    const productVendor = this.getAttribute("data-product-vendor");
    const productVariant = this.getAttribute("data-product-variant");
    const productPrice = this.getAttribute("data-product-price");
    const productCollection = this.getAttribute("data-product-collection");
    const CollectionId = this.getAttribute("data-collection-id");
    const indexNumber = this.getAttribute("product-index-number");
    gtag("event", "select_item", {
      send_to: "G-WQS1KBXWX1",
      item_list_id: CollectionId ? CollectionId : "home",
      item_list_name: productCollection ? productCollection : "home",
      items: [
        {
          item_id: productId,
          item_name: productName,
          index: indexNumber,
          item_brand: productVendor,
          item_list_id: CollectionId ? CollectionId : "home",
          item_list_name: productCollection ? productCollection : "home",
          item_variant: productVariant,
          price: productPrice,
          quantity: 1,
        },
      ],
    });
  };

  const attachEventListeners = () => {
    console.log("focus");
    Array.from(collectionItems).forEach(function (element) {
      element.addEventListener("click", handleClick);
    });
  };

  const removeEventListeners = () => {
    Array.from(collectionItems).forEach(function (element) {
      element.removeEventListener("click", handleClick);
    });
  };

  attachEventListeners();
});
